import { useEffect } from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  ogImage?: string;
  articlePublishedTime?: string;
  articleModifiedTime?: string;
  articleAuthor?: string;
  articleTags?: string[];
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogTitle,
  ogDescription,
  ogType = 'website',
  ogImage,
  articlePublishedTime,
  articleModifiedTime,
  articleAuthor,
  articleTags,
}: SEOHeadProps) {
  useEffect(() => {
    if (typeof document === 'undefined') {
      return null;
    }

    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('keywords', keywords);

    const canonicalEl = document.querySelector('link[rel="canonical"]');
    if (canonicalEl) {
      canonicalEl.setAttribute('href', canonicalUrl);
    } else {
      const link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      link.setAttribute('href', canonicalUrl);
      document.head.appendChild(link);
    }

    setMeta('og:title', ogTitle || title, true);
    setMeta('og:description', ogDescription || description, true);
    setMeta('og:type', ogType, true);
    setMeta('og:url', canonicalUrl, true);
    if (ogImage) setMeta('og:image', ogImage, true);

    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', ogTitle || title);
    setMeta('twitter:description', ogDescription || description);

    if (articlePublishedTime) {
      setMeta('article:published_time', articlePublishedTime, true);
    }
    if (articleModifiedTime) {
      setMeta('article:modified_time', articleModifiedTime, true);
    }
    if (articleAuthor) {
      setMeta('article:author', articleAuthor);
    }
    if (articleTags && articleTags.length > 0) {
      articleTags.forEach((tag) => {
        setMeta('article:tag', tag, true);
      });
    }

    return () => {
      document.title = '17吃瓜网官网 | 17吃瓜爆料 - 网红黑料每日更新';
    };
  }, [title, description, keywords, canonicalUrl, ogTitle, ogDescription, ogType, ogImage, articlePublishedTime, articleModifiedTime, articleAuthor, articleTags]);

  return null;
}